import { postData } from 'helpers/RequestHelper';

export const trackEvent = async (eventType) => {
  await postData({
    url: '/register/track_event',
    body: {
      client_time: Date.now(),
      event_type: eventType
    }
  });
};

export const trackFieldUpdate = async (fieldName, fieldValue, fieldType) => {
  await postData({
    url: '/register/track_field_update',
    body: {
      field_name: fieldName,
      field_value: fieldValue,
      field_type: fieldType,
      client_time: Date.now()
    }
  });
};

export const trackRenewViewEvent = async () => {
  await postData({
    url: '/register/track_event',
    body: {
      event_type: `${window.AppConfig.renew_type}_view`,
      client_time: Date.now()
    }
  });
};
